module.exports = __webpack_public_path__ + "BlackCraneCreations.jpg?bfa775a0f4da161bd841eaf7b8159d0c";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/BlackCraneCreations.jpg
// module id = 443
// module chunks = 0